import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const getAllUsersDetailsSlice = createApi(`GetAllUsersDetailsSlice`,"GET");

const GetAllUsersDetailsSlice = createSlice({
  name: 'GetAllUsersDetailsSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllUsersDetailsSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllUsersDetailsSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getAllUsersDetailsSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GetAllUsersDetailsSlice.reducer;